function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var _templateObject, _templateObject2, _templateObject3;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { css, html } from "lit";
import { QuoteElement } from "./quote-element.js";
import { property } from "lit/decorators.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;

var __decorateClass = function __decorateClass(decorators, target, key, kind) {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;

  for (var i = decorators.length - 1, decorator; i >= 0; i--) {
    if (decorator = decorators[i]) result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  }

  if (kind && result) __defProp(target, key, result);
  return result;
};

var _MultiOfferQuoteElement = /*#__PURE__*/function (_QuoteElement) {
  _inherits(_MultiOfferQuoteElement, _QuoteElement);

  var _super = _createSuper(_MultiOfferQuoteElement);

  function _MultiOfferQuoteElement() {
    var _this;

    _classCallCheck(this, _MultiOfferQuoteElement);

    _this = _super.apply(this, arguments);
    _this.multiMode = false;
    return _this;
  }

  _createClass(_MultiOfferQuoteElement, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return this.quoteController.render({
        complete: function complete() {
          return _this2.multiMode ? _this2._renderMultiDisplay() : _this2._renderStandardDisplay();
        },
        error: function error(e) {
          if (!_this2.multiMode) {
            return _this2._renderStandardErrorDisplay(e);
          }

          return html(_templateObject || (_templateObject = _taggedTemplateLiteral([""])));
        }
      });
    }
    /**
     * @ignore
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars

  }, {
    key: "_renderStandardErrorDisplay",
    value: function _renderStandardErrorDisplay(e) {
      return html(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
    }
  }]);

  return _MultiOfferQuoteElement;
}(QuoteElement);

_MultiOfferQuoteElement.styles = [QuoteElement.styles, css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n      :host {\n        width: 100%;\n      }\n\n      offer-checkbox-button {\n        display: block;\n        width: 100%;\n        border-radius: var(--default-vi-action-border-radius);\n        border: 1px solid var(--default-vi-border-color);\n      }\n\n      .multi-offer-item {\n        display: flex;\n        flex: 1;\n        column-gap: 15px;\n        width: 100%;\n        line-height: 1.25rem;\n      }\n      .multi-offer-item div:first-child {\n        flex: 1;\n      }\n    "])))];
var MultiOfferQuoteElement = _MultiOfferQuoteElement;

__decorateClass([property({
  attribute: "coverage-context-description"
})], MultiOfferQuoteElement.prototype, "coverageContextDescription", 2);

__decorateClass([property({
  type: Boolean,
  attribute: "multi-mode"
})], MultiOfferQuoteElement.prototype, "multiMode", 2);

export { MultiOfferQuoteElement };